import React from 'react';
import FastImage from 'react-native-fast-image';

import Theme from '../../../theme';

export const CalorieIcon = ({
                              color = Theme.WHITE,
                              width,
                              height
                            }) => (
  <FastImage
    resizeMode='contain'
    style={{
      width,
      height,
    }}
    tintColor={color}
    source={require('../../../assets/images/kcals-white.png')}
  />

);
